module.exports = __webpack_public_path__ + "img/5.49eb4a17.svg";